<template>
  <v-app>
    <v-content>
      <v-container grid-list-md>
        <form id="form1"
              v-show="isshow">
          <table border="1"
                 width="300"
                 id="tb01">
            <tr>
              <td width="133"
                  id="mtb001">
                <h2 style="background:pink;">我是表头</h2>
              </td>
            </tr>
          </table>
          <table border="1"
                 width="300"
                 height="106"
                 cellspacing="0">
            <tr>
              <td>姓名</td>
              <td>年龄</td>
              <td>性别</td>
            </tr>
            <tr>
              <td>张三</td>
              <td>22</td>
              <td>女</td>
            </tr>
          </table>
        </form>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { getLodop } from '@/assets/js/LodopFuncs'

export default {
  data () {
    return {
      items: [],
      isshow: true
    }
  },
  mounted () {
    // 发送查询请求
    this.$http
      // dev
      // .get('/api/detail/' + this.$route.query.id)
      // product
      .get('/api/queryfr/certificates_detail?id=' + this.$route.query.id)
      .then(res => {
        var rcode = res.data.code
        if (rcode !== 200) {
          this.$message.error(res.data.msg)
        } else {
          this.$message.success(res.data.msg)
          this.items = res.data.data
        }
      })
      .catch(err => {
        this.$message.error(err.msg)
      })
  },
  methods: {
    handlePrint (s) {
      let LODOP = getLodop()
      switch (s) {
        case 0:
          this.$message.success('直接打印')
          LODOP.PRINT() //直接打印
        case 1:
          this.$message.success('打印预览')
          LODOP.PRINT_INIT('采购单')
          LODOP.SET_PRINT_STYLE('FontSize', 18)
          LODOP.SET_PRINT_STYLE('Bold', 1)
          LODOP.ADD_PRINT_TEXT(50, 300, 260, 39, '采购单')
          LODOP.ADD_PRINT_HTM(
            88,
            200,
            350,
            600,
            document.getElementById('form1').innerHTML
          )
          LODOP.PREVIEW() //打印预览
        case 2:
          this.$message.success('打印维护')
          LODOP.PRINT_SETUP() //打印维护
        case 3:
          this.$message.success('打印设计')
          LODOP.PRINT_DESIGN() //打印设计
      }
    }
  }
}
</script>

<style scoped>
</style>